export const LocalizableType = Object.freeze({
    country: "country",
    language: "language",
});
